import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';
import { getStore } from '@core/store';

bus.on(constants.EVENTS.BOOKMAKER.DETAIL.REFRESH, (data) => {
  const bookmakerId = data.bookmakerId;
  const bookmaker = data.bookmaker;
  const requestId = `bookmakerDetail-${Date.now()}`;
  const store = getStore('bookmaker');
  if (store.state?.bookmakerData?.[`${bookmaker}_${bookmakerId}`]?.data) return;
  const decodableBookmakers = ['1xbet', 'betwinner'];
  if (!decodableBookmakers.includes(bookmaker)) {
    bus.emit(constants.EVENTS.BOOKMAKER.DETAIL.REFRESHED, {
      name: '',
      playerId: `${bookmakerId}`,
      bookmaker,
      bookmakerId
    });
    return
  }

  bus.emit(constants.EVENTS.BOOKMAKER.DETAIL.REFRESHING, {
    bookmaker,
    bookmakerId
  });
  let url = `${constants.ENDPOINTS.BOOKMAKER.GET_LIST}`;
  url = url.replace(/{bookmaker}/, bookmaker);
  url = url.replace(/{accountId}/, bookmakerId);

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res, { bookmakerId });
      if (parsed.success) {
        bus.emit(constants.EVENTS.BOOKMAKER.DETAIL.REFRESHED, {
          ...parsed.data,
          bookmaker,
          bookmakerId
        });
      } else {
        bus.emit(constants.EVENTS.BOOKMAKER.DETAIL.REFRESH_ERROR, {
          ...parsed,
          bookmaker,
          bookmakerId
        });
      }
    }
  });
});

bus.on(constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION, (data) => {
  const bookmakerId = data.bookmakerId;
  const bookmaker = data.bookmaker;
  bus.emit(constants.EVENTS.BOOKMAKER.DETAIL.REFRESH, {
    bookmakerId,
    bookmaker
  });
});
